module.exports = __webpack_public_path__ + "static/media/ragazza.bd9506bd.jpg";